<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.modos') }}</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table 
                            :exportable="exportable"
                            :mostrarTodos="false"
                            @editar="editar"
                            @eliminar="eliminar"
                            @crear="crear"
                            :columns="columns"
                            :path="path"
                            ref="listaModos"
                            :deleteButton="deleteButton && permiteEliminar" 
                            :createButton="permiteCrear" 
                            :editButton="editButton && permiteEditar"></k-table>
                    </div>
                </div>
            </div>
        </div>
        <modal :clickToClose="false" name="modo" width="60%" height="auto" scrollable>
            <modo :title="title"  @saved="saved" @cancelar="cancelar" v-model="selectedItem"></modo>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        permiteCrear : {
            type : Boolean,
            required : false, 
            default : true
        },
        permiteEditar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        permiteEliminar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        exportable : {
            type : Boolean,
            required : false,
            default : false
        },
        tituloFormulario : {
            type : String,
            required : false,
            default : 'Modos'
        },
        descripcionFormulario : {
            type : String,
            required : false,
            default : 'Lista de modos'
        },
        title : {
            type : String,
            required : false,
            default : 'Modo'
        },
        createButton : {
            required : false,
            default : true,
            type : Boolean
        },
        editButton : {
            required : false,
            default : true,
            type : Boolean
        },
        deleteButton : {
            required : false,
            default : true,
            type : Boolean
        },
        path : {
            type : String,
            required : false, 
            default : url + '/modos'
        },
        codigoText : {
            type : String,
            required : false,
            default : 'Código'
        },
        descripcionText : {
            type : String,
            required : false,
            default : 'Descripción'
        },
        tipoText : {
            type : String,
            required : false,
            default : 'Tipo'
        },
        creacionText : {
            type : String,
            required : false,
            default : 'Creación'
        },
        modificacionText : {
            type : String,
            required : false,
            default : 'Modificación'
        },
        columns : {
            type : Array,
            required : false,
            default : function () {
                return [
                    {
                        display : this.$t('message.codigo'),
                        value : 'codigo'
                    },
                    {
                        display : this.$t('message.descripcion'),
                        value : 'descripcion'
                    },
                    {
                        display : this.$t('message.creacion'),
                        value : 'created_at'
                    },
                    {
                        display : this.$t('message.modificacion'),
                        value : 'updated_at'
                    }
                ];
            }
        }
    },
    data : function () {
        return {
            selectedIndex : -1,
            selectedItem : null,
            tipoGuardado : 'N',
            url : url
        }
    },
    methods : {
        crear : function () {
            this.selectedIndex = -1;
            this.tipoGuardado = 'N';
            this.selectedItem = {
                id : '',
                codigo : '',
                descripcion : '',
                estado : 'N'
            };
            this.$modal.show('modo');
        },
        editar : function (row) {
            this.selectedIndex = this.$refs.listaModos.rows.indexOf(row);
            this.tipoGuardado = 'E';
            this.selectedItem = {
                id : row.id,
                codigo : row.codigo,
                descripcion : row.descripcion,
                estado : row.estado
            };
            this.$modal.show('modo');
        },
        eliminar : function (row) {
            this.selectedIndex = this.$refs.listaModos.rows.indexOf(row);
            this.selectedItem = row;
            let enabled = row.estado === 'A';
            let that = this;
            swal({
                title: (this.$t('message.deseas') + ' ' + (enabled?this.$t('message.desactivar'):this.$t('message.activar')) + ' ' + this.$t('message.esteRegistro') + ' ? '),
                text: this.$t('message.requiereConfirmacion'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: that.$t('message.confirmar'),
                cancelButtonText : that.$t('message.cancelar')
                }).then((result) => {
                    if (result.value) {
                        axios.post(that.url + '/modos/' + row.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            swal(that.$t('message.elRegistro') + ' ' + (enabled?that.$t('message.desactivado'):that.$t('message.activado')) + '.', that.$t('message.aviso'), 'success');
                            that.$refs.listaModos.rows.splice(that.selectedIndex, 1);
                            that.selectedIndex = -1;
                            that.selectedItem = null;
                        }).catch(function (error) {
                            if (error !== null && error !== undefined) {
                                let response = error.response;
                                if (response !== undefined && response !== null) {
                                    let status = response.status;
                                    if (status === 404)
                                        swal(that.$t('message.noPuedeEliminar'), that.$t('message.aviso'), 'warning');
                                    else 
                                        swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                                }
                            }
                        });
                    }
                    else {
                        that.selectedIndex = -1;
                        that.selectedItem = null;
                    }
                });
        },
        cancelar : function () {
            this.selectedIndex = -1;
            this.selectedItem = null;
            this.$modal.hide('modo');
        },
        saved : function(row) {
            if (this.selectedIndex === -1)
                this.$refs.listaModos.rows.unshift(row);
            else 
                this.$refs.listaModos.rows.splice(this.selectedIndex, 1, row);
            this.selectedIndex = -1;
            this.selectedItem = -1;
            this.$modal.hide('modo');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/modos/ListaModos.vue